import {action, observable} from 'mobx';
import agent from '../../api/agent';
import navigatorStore from '../navigatorStore'

class categoryArtworksStore {

    @observable query = {};
    @observable title = "";
    @observable paginationLimit = 20;
    @observable paginationOffset = 0;

    @action setQuery(input, title) {

        // console.log("setting the query", input, title)

        this.query = input
        this.title = title
    }

    @action getAllArtworksByCategory(query, hideTheLoader) {
        // console.log(this.paginationOffset)
        // let queryString = querystring.stringify({limit : this.paginationLimit ,offset : this.paginationOffset });
        if (query == 'search=') {
            //borwse all artowrks api called
            return agent.CategoryArtworks.getBrowseAllArtworks(query, {
                limit: this.paginationLimit,
                offset: parseInt(this.paginationOffset)
            }, hideTheLoader)
                .catch(action(err => {
                    // this.commentErrors = err.response && err.response.body && err.response.body.errors;
                    navigatorStore.openErrorModal("Something went wrong. Please try again.");
                }))

        } else {
            return agent.CategoryArtworks.getArtworksByCategory(query, {
                limit: this.paginationLimit,
                offset: parseInt(this.paginationOffset)
            }, hideTheLoader)
                .catch(action(err => {
                    // this.commentErrors = err.response && err.response.body && err.response.body.errors;
                    navigatorStore.openErrorModal("Something went wrong. Please try again.");
                }))
        }

    }
    @action getAllArtworksByCategoryPublic(query) {
        // console.log(this.paginationOffset)
        // let queryString = querystring.stringify({limit : this.paginationLimit ,offset : this.paginationOffset });
        if (query == 'search=') {
            return agent.CategoryArtworks.getBrowseAllArtworksPublic(query, {limit: 20, offset: 0})
                .catch(action(err => {
                    // this.commentErrors = err.response && err.response.body && err.response.body.errors;
                    navigatorStore.openErrorModal("Something went wrong. Please try again.");
                }))

        } else {
            return agent.CategoryArtworks.getArtworksByCategoryPublic(query, {limit: 20, offset: 0})
                .catch(action(err => {
                    // this.commentErrors = err.response && err.response.body && err.response.body.errors;
                    navigatorStore.openErrorModal("Something went wrong. Please try again.");
                }))
        }

    }
    @action getAll() {
        // console.log(this.paginationOffset)
        // let queryString = querystring.stringify({limit : this.paginationLimit ,offset : this.paginationOffset });
        return agent.CategoryArtworks.getRecentArtworks({ limit: this.paginationLimit, offset: parseInt(this.paginationOffset) })
            .catch(action(err => {
                // this.commentErrors = err.response && err.response.body && err.response.body.errors;
                navigatorStore.openErrorModal("Something went wrong. Please try again.");
            }))
    }

    @action loadmore() {
        // console.log("came here")
        this.paginationOffset = this.paginationOffset + 20;
        // this.paginationLimit = this.paginationLimit + 25;
        // console.log(this.paginationOffset)
        // this.getAllArtworks()
    }
    @action resetPagination() {
        this.paginationLimit = 20;
        this.paginationOffset = 0;
    }
}

export default new categoryArtworksStore()


// WEBPACK FOOTER //
// ./src/stores/artworksStores/categoryPageArtworksStore.js